import React from 'react'
import ModalWrapper from './ModalWrapper'

const UPLOAD_KINDS = [
  'mediaUploadFailed',
  'unsupportedSoundType',
  'unsupportedImageType',
  'fileTooLarge',
]

function isUploadKind(kind) {
  return UPLOAD_KINDS.includes(kind)
}

/** Upload / media-service validation errors */
function AppErrorModalUploadSection({ kind, message }) {
  return (
    <React.Fragment>
      {kind === 'mediaUploadFailed' && (
        <div className='appError-modalContent-header'>
          Failed to upload your file. Please check your internet connection and try again.
        </div>
      )}

      {kind === 'unsupportedSoundType' && (
        <div className='appError-modalContent-header'>
          {message || 'The audio file format is not supported. Supported formats: mp3, wav, ogg, m4a, flac, aac, webm, mp4.'}
        </div>
      )}

      {kind === 'unsupportedImageType' && (
        <div className='appError-modalContent-header'>
          {message || 'The image file format is not supported. Supported formats: png, jpg, jpeg, webp, avif, bmp, gif.'}
        </div>
      )}

      {kind === 'fileTooLarge' && (
        <div className='appError-modalContent-header'>
          {message || 'The file is too large to upload.'}
        </div>
      )}
    </React.Fragment>
  )
}

/** Network / domain allowlist guidance */
function AppErrorModalNetworkSection({ kind }) {
  return (
    <React.Fragment>
      {kind === 'imageSearch' && (
        <div className='appError-modalContent-header'>
          Failed to search for images because your network internet is blocking access to Plickers&apos; image search.
        </div>
      )}

      {kind === 'imageSearch' && (
        <div>
          The good news is, your IT administrator should be able to fix this.
          {' '}
          <br />
          If you send them the following message it should help them:
          {' '}
          <br />
          <div className='appError-modalContent-messageContents'>
            Plickers requires the following domains to be whitelisted:
            <br />
            <br />
            <b>*.giphy.com</b>
            {' '}
            – used for GIPHY search and hosting
            <br />
            <b>*.googleapis.com</b>
            {' '}
            – used for YouTube search
            <br />
            <b>*.youtube.com</b>
            {' '}
            – used for YouTube video delivery
            <br />
            <br />
            Some of these domains are currently inaccessible, restricting Plickers&apos; functionality.
            <br />
          </div>

          If you have any questions, don&apos;t hesitate to contact support help@plickers.com
        </div>
      )}

      {kind === 'gifSearch' && (
        <div>
          Failed to complete gif search. Please make sure giphy.com is whitelisted in your network.
        </div>
      )}
    </React.Fragment>
  )
}

function AppErrorModal({ appErrorKind, appErrorMessage, hideModal }) {
  const upload = isUploadKind(appErrorKind)

  return (
    <div className='appError-modalContainer'>
      <ModalWrapper
        hideModal={hideModal}
        title={upload ? 'Upload Error' : 'Network Error'}
        modalStyle='light'
      >
        <div className='appError-modalContent'>
          {upload ? (
            <AppErrorModalUploadSection kind={appErrorKind} message={appErrorMessage} />
          ) : (
            <AppErrorModalNetworkSection kind={appErrorKind} />
          )}
        </div>
      </ModalWrapper>
    </div>
  )
}

export default AppErrorModal
